import { BASE_URL } from "../utils/constant";
import { Endpoints } from "./endpoint";
import axios from "axios";

const loginService = (obj) => {
  return axios.post(BASE_URL + Endpoints.login, obj);
}

export { loginService };
